import React from "react";
import { observer } from "mobx-react";
import "../custom.css";

@observer
class DineTakeawayToggle extends React.Component {
  constructor(props) {
    super(props);
    // Lấy trạng thái từ preQuestions.input_method nếu có
    const preQuestionsKey = `${props.cartStore.menuStore.controller}_preQuestions`;
    let preQuestions = {};
    try {
      preQuestions = JSON.parse(localStorage.getItem(preQuestionsKey)) || {};
    } catch (e) {}
    let orderType = "dinein";
    if (
      preQuestions.input_method === "Take Away" ||
      props.cartStore.menuStore.takeaway === "2"
    ) {
      orderType = "takeaway";
    }
    this.state = {
      orderType: orderType,
      dropdownOpen: false,
    };
    this.dropdownRef = React.createRef();
  }

  handleOrderTypeChange = (type) => {
    // Cập nhật input_method trong preQuestions trước
    const preQuestionsKey = `${this.props.cartStore.menuStore.controller}_preQuestions`;
    let preQuestions = {};
    try {
      preQuestions = JSON.parse(localStorage.getItem(preQuestionsKey)) || {};
    } catch (e) {}
    preQuestions.input_method = type === "takeaway" ? "Take Away" : "Dine In";
    localStorage.setItem(preQuestionsKey, JSON.stringify(preQuestions));

    // Sau đó cập nhật cartStore và state
    this.setState({ orderType: type, dropdownOpen: false });
    if (type === "takeaway") {
      this.props.cartStore.menuStore.takeaway = "2";
      this.props.cartStore.takeAway = true;
    } else {
      this.props.cartStore.menuStore.takeaway = "1";
      this.props.cartStore.takeAway = false;
    }
  };

  handleDropdownToggle = () => {
    this.setState((prev) => ({ dropdownOpen: !prev.dropdownOpen }));
  };

  handleClickOutside = (event) => {
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ dropdownOpen: false });
    }
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    // Chỉ cập nhật state nếu giá trị thực sự khác với state hiện tại
    const preQuestionsKey = `${this.props.cartStore.menuStore.controller}_preQuestions`;
    let preQuestions = {};
    try {
      preQuestions = JSON.parse(localStorage.getItem(preQuestionsKey)) || {};
    } catch (e) {}
    let orderType = "dinein";
    if (
      preQuestions.input_method === "Take Away" ||
      this.props.cartStore.menuStore.takeaway === "2"
    ) {
      orderType = "takeaway";
    }
    if (
      this.props.cartStore.menuStore.takeaway !==
        prevProps.cartStore.menuStore.takeaway ||
      orderType !== this.state.orderType
    ) {
      // Nếu state đã đúng thì không set lại nữa
      if (this.state.orderType !== orderType) {
        this.setState({ orderType });
      }
    }
  }

  render() {
    const { orderType, dropdownOpen } = this.state;
    const { cartStore } = this.props;
    const isCocoList = cartStore.menuStore.layout === 4;
    const options = [
      { value: "dinein", label: "Dine In" },
      { value: "takeaway", label: "Takeaway" },
    ];

    const found = options.find((opt) => opt.value === orderType);
    const selectedLabel = found ? found.label : "";

    const preQuestionsKey = `${cartStore.menuStore.controller}_preQuestions`;
    let preQuestions = {};
    try {
      preQuestions = JSON.parse(localStorage.getItem(preQuestionsKey)) || {};
    } catch (e) {}
    const hasInputMethod = preQuestions.hasOwnProperty("input_method");

    const dropdown = hasInputMethod ? (
      <div className="custom-dropdown" ref={this.dropdownRef}>
        <div
          className="custom-dropdown-selected"
          onClick={this.handleDropdownToggle}
        >
          {selectedLabel}
          <span className="custom-dropdown-arrow" />
        </div>
        {dropdownOpen && (
          <div className="custom-dropdown-menu">
            {options.map((opt) => (
              <div
                key={opt.value}
                className={`custom-dropdown-item${
                  orderType === opt.value ? " selected" : ""
                }`}
                onClick={() => this.handleOrderTypeChange(opt.value)}
              >
                {opt.label}
              </div>
            ))}
          </div>
        )}
      </div>
    ) : null;

    if (isCocoList) {
      // Nếu không có dropdown, căn giữa Table #
      const onlyTableCenter = !dropdown;
      
      // Check if user is logged in
      const social = cartStore.menuStore.social;
      const isLoggedIn = social && (social.provider || social.name);
      
      return (
        <div
          className="cocolist-dine-takeaway"
          style={{
            background: "#fff",
            color: "#111",
            borderRadius: 8,
            padding: "12px 16px",
            display: "flex",
            justifyContent: onlyTableCenter ? "space-between" : "space-between",
            alignItems: "center",
            position: "relative",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <div>
              {isLoggedIn && (
                <div className="member-greeting-coco-inline">
                  Hi {social.firstName || "Member"}!
                </div>
              )}
            </div>
            <div style={{ fontWeight: "bold", fontSize: 16 }}>
              Table # {cartStore.menuStore.getRealTagValue() || "---"}
            </div>
          </div>
          {dropdown}
        </div>
      );
    }

    return (
      <div className="dine-takeaway-section">
        <div className="DineInTakeAway options">
          <div
            className={`option ${orderType === "dinein" ? "active" : ""}`}
            onClick={() => this.handleOrderTypeChange("dinein")}
            style={{
              background: "url(/theme/img/dinein2.jpg) no-repeat center center",
              backgroundSize: "cover",
              height: "150px",
              border:
                orderType === "dinein" ? "3px solid #E41026" : "1px solid #ddd",
            }}
          >
            <div className="option-overlay">
              <span className="option-text">Dine In</span>
            </div>
          </div>
          <div
            className={`option ${orderType === "takeaway" ? "active" : ""}`}
            onClick={() => this.handleOrderTypeChange("takeaway")}
            style={{
              background:
                "url(/theme/img/takeaway.jpg) no-repeat center center",
              backgroundSize: "cover",
              height: "150px",
              border:
                orderType === "takeaway"
                  ? "3px solid #E41026"
                  : "1px solid #ddd",
            }}
          >
            <div className="option-overlay">
              <span className="option-text">Takeaway</span>
            </div>
          </div>
        </div>
        <div style={{ marginTop: 16 }}>{dropdown}</div>
      </div>
    );
  }
}

export default DineTakeawayToggle;
